/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-04 15:11:01
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2020-12-02 18:03:53
 */
export const oldBaseURL = process.env.VUE_APP_OLD_BASE_API
export const baseURL = process.env.VUE_APP_BASE_URL
export const javaBaseURL = process.env.VUE_APP_JAVA_BASEURL

/**
 *  app版本号
 */
export const APP_VERSION = '3.6.0'
